import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    selectSingle: {
        id: 'blsq.treeview.label.selectSingle',
        defaultMessage: 'Select an org unit',
    },
    selectMultiple: {
        id: 'blsq.treeview.label.selectMultiple',
        defaultMessage: 'Select org unit(s)',
    },
    clear: {
        id: 'blsq.treeview.search.options.label.clear',
        defaultMessage: 'Clear',
    },
    confirm: {
        id: 'blsq.treeview.search.confirm',
        defaultMessage: 'Confirm',
    },
    cancel: {
        id: 'blsq.treeview.search.cancel',
        defaultMessage: 'Cancel',
    },
    error: {
        id: 'blsq.treeview.error',
        defaultMessage: 'Please select an org unit',
    },
    displayTypes: {
        id: 'blsq.treeview.displayTypes',
        defaultMessage: 'Show organisation unit types',
    },
    displayVALID: {
        id: 'blsq.treeview.displayValid',
        defaultMessage: 'Show valid organisation unit types',
    },
    displayREJECTED: {
        id: 'blsq.treeview.displayRejected',
        defaultMessage: 'Show rejected organisation unit',
    },
    displayNEW: {
        id: 'blsq.treeview.displayNew',
        defaultMessage: 'Show new organisation unit types',
    },
    source: {
        defaultMessage: 'Source',
        id: 'iaso.forms.source',
    },
    version: {
        defaultMessage: 'Version',
        id: 'iaso.label.version',
    },
    default: {
        id: 'iaso.datasources.options.label.default',
        defaultMessage: 'default',
    },
});

export { MESSAGES };
